import FirebaseModel from "@/Store/ORM/FirebaseORM/FirebaseModel";

export default class BillingFixedPrice extends FirebaseModel {
	static entity = 'billingFixedPrices';
	static baseCollection = this.firestore.collection('Configs').doc('Belit').collection('fixed_prices');
	static fields(){
		return {
			name: this.attr(null),
			is_customer: this.attr(null),
			allowed_categories: this.attr(null),
			only_has_tests: this.attr(null),
			optional_test_additions: this.attr(null),
			has_flags: this.attr(null),
			amount: this.number(0),
			optional_amount_addition: this.number(0),
			allow_percent_discount: this.boolean(false),
			priority: this.attr(null),
			...super.fields()
		}
	}
}
